import CardFeature from '~/components/Molecules/CardFeature/CardFeature.vue'

export default {
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    body: {
      type: String,
    },
    button: {
      type: Object,
    },
    item: {
      type: Object,
    },
  },

  data() {
    return {
      cardFeature: CardFeature,

      swiperOptions: {
        slidesPerView: 1.1,
        spaceBetween: 16,
        allowTouchMove: true,
        breakpoints: {
          480: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 2,
            allowTouchMove: false,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },

      fractionPagination: true,
    }
  },
}
